import React from 'react'

export default function OrdersList() {
	return (
		<React.Fragment></React.Fragment>
	)
}